import get from 'lodash/get';
import { boolCheckboxSpec, group } from '../../lib/editing-configs';
import UniversalAuthButton from '../universal-auth-button/universal-auth-button';
import UniversalButton from '../universal-button/universal-button';
import UniversalContainer from '../universal-container';
import UniversalText from '../universal-text/universal-text';

export default (componentDocument) => {
  const authButtonConfig = componentDocument?.props?.includeSignUpButtons
    ? [...UniversalAuthButton.getEditingConfig(componentDocument, 'authButton')]
    : [];

  const centeredInParentBackgroundInputConfig = componentDocument?.props
    ?.includeParentWidthLimitation
    ? [
        ...UniversalContainer.getEditingConfig(
          componentDocument,
          'Centered Parent Background',
          ['backgroundColor', 'backgroundImage', 'padding', 'hide'],
          'centeredInParentBackground',
          {
            disableGroup: true,
            customLabels: {
              background: 'Centered In Parent Background',
            },
          }
        ),
      ]
    : [];

  return [
    boolCheckboxSpec('disableDefaultProps', 'Disable Default Properties?'),
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'hide',
        'margin',
        'padding',
        'jumpLinkId',
      ],
      'container'
    ),
    ...UniversalText.getEditingConfig(
      componentDocument,
      'Title',
      [
        'textSize',
        'textType',
        'fontWeight',
        'padding',
        'margin',
        'groupButton',
        'fontFamily',
        'textColor',
      ],
      'title'
    ),
    ...UniversalText.getEditingConfig(
      componentDocument,
      'Subtitle',
      [
        'textSize',
        'textType',
        'fontWeight',
        'padding',
        'margin',
        'groupButton',
        'fontFamily',
        'textColor',
      ],
      'subtitle'
    ),
    ...UniversalButton.getEditingConfig(
      componentDocument,
      'actionButton',
      'Button',
      ['displayStyle', 'disabled', 'ctaSubText', 'loadingMessage', 'alignment'],
      'actionButton'
    ),
    group('Options', [
      boolCheckboxSpec('includeSignUpButtons', 'Add Sign Up buttons?'),
      ...authButtonConfig,
      boolCheckboxSpec(
        'includeContentWidthLimitation',
        'Output Header and Body 2/3 width?'
      ),
      boolCheckboxSpec(
        'includeParentWidthLimitation',
        'Limit width of container to centered-in-parent?'
      ),
      ...(get(componentDocument, 'props.includeParentWidthLimitation', false)
        ? [...centeredInParentBackgroundInputConfig]
        : []),
    ]),
  ];
};
